import { QueryClient } from '@tanstack/react-query'

import { ApiError, SessionExpiredError } from './errors'

/**
 * ⚠️ C11 — 두 이용권 EP 는 Reader DB 로 라우팅된다. 낙관적 캐시를 두면 복제 지연과 겹쳐
 * "갱신했는데 화면은 옛 상태"가 캐시 때문인지 복제 때문인지 구분할 수 없게 된다.
 * `staleTime: 0` + 포커스 재조회로 항상 서버 값을 신뢰한다.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 0,
        refetchOnWindowFocus: true,
        retry: (failureCount, error) => {
          // 인가 실패·없는 자원·세션 만료는 재시도해도 결과가 같다.
          if (error instanceof SessionExpiredError) return false
          if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false
          return failureCount < 1
        },
      },
      mutations: { retry: false },
    },
  })
}
